import { sharedSummaryTabStyles } from './styles'

export default {
  ...sharedSummaryTabStyles,
  backgroundColor: '#efefef',
  color: '#404040',
  '&:hover': {
    backgroundColor: '#e7e7e7'
  }
}



// WEBPACK FOOTER //
// ./src/styles/tabs/summary.js